<template>
  <v-dialog
    v-model="dialog"
    width="320px"
    scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="btn"
        v-bind="attrs"
        class="snt-btn--rounded"
        color="success"
        outlined
        v-on="on">
        {{ $t('approve') }}
      </v-btn>
      <v-list-item
        v-else
        v-bind="attrs"
        link
        v-on="on">
        <v-list-item-subtitle>
          {{ $t('approve') }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
    <v-card class="snt-template-publish__card">
      <v-card-title class="pt-6 px-6 pb-0"></v-card-title>
      <v-card-text class="px-6">
        <div class="snt-template-publish__action">
          <v-btn
            x-small
            icon
            @click="setDialog(false)">
            <v-icon
              color="#6C6C6C"
              size="14">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <div class="text-center mb-4">
          <v-icon size="53">
            $snt_puiblish
          </v-icon>
        </div>
        <div class="snt-template-publish__title">
          {{ $t('publish.title') }}
        </div>
        <div class="snt-template-publish__description">
          {{ $t('publish.description') }}
        </div>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer />
        <v-btn
          class="snt-template-publish__btn px-4"
          text
          @click="setDialog(false)">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          :loading="submitting"
          class="snt-template-publish__btn px-4 ml-3"
          color="primary"
          depressed
          @click="submit()">
          {{ $t('approve') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UPDATE_STATUS_SALEPAGETEMPLATE } from '@/resources/graphql'

export default {
  props: {
    itemId: {
      type: [Number, String],
      required: true
    },
    btn: {
      type: [Boolean],
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      submitting: false,
      valid: false
    }
  },
  methods: {
    async submit () {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: UPDATE_STATUS_SALEPAGETEMPLATE,
        variables: {
          input: {
            id: this.itemId,
            status: 'PUBLISHED'
          }
        }
      })
      this.submitting = false
      this.$emit('click:submit')
    },
    setDialog (dialog = false) {
      this.dialog = dialog
    }
  }
}
</script>

<style scoped>
  .snt-template-action .v-list-item__subtitle {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6B6B6B;
  }
  .snt-template-publish__card {
    border-radius: 8px;
  }
  .snt-template-publish__action {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .snt-template-publish__title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #6B6B6B;
  }
  .snt-template-publish__description {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #B1B1B1;
  }
  .snt-template-publish__btn {
    border-radius: 8px;
  }
</style>
